import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
TranslationsController.$inject = ["API_URL", "$http", "$rootScope"];
angular.module('userApp').controller('TranslationsController', TranslationsController);

function TranslationsController(API_URL, $http, $rootScope) {
  var tran = this,
      throbber = $rootScope.throbber; // The idea is that default translations are provided but over-ridden by anything in the DB

  tran.init =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _ref2, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return $http.get("".concat(API_URL, "/api/v1/settings/translations"));

          case 3:
            _ref2 = _context.sent;
            data = _ref2.data;
            tran.translations = data.translations;
            $rootScope.safeApply();
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0.message);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 9]]);
  }));
  tran.init();

  tran.editTranslation =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(index) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                tran.keyEdit = tran.translations[index].key;
                tran.translationEdit = tran.translations[index].translation;
                tran.translations[index].editing = true;
              } catch (err) {
                console.error(err.message);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  tran.updateTranslation =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(translationID) {
      var update, result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              update = {
                key: tran.keyEdit,
                translation: tran.translationEdit
              };
              throbber.show();
              _context3.next = 5;
              return $http.put("".concat(API_URL, "/api/v1/settings/translations/").concat(translationID), {
                update: update
              });

            case 5:
              result = _context3.sent;
              tran.init();
              $rootScope.safeApply();
              throbber.hide('Translation updated');
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0.message);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 11]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  tran.cancelEdit = function () {
    tran.translations = tran.translations.map(function (translation) {
      return _objectSpread({}, translation, {
        editing: false
      });
    });
  };

  tran.deleteTranslation =
  /*#__PURE__*/
  function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(translationID) {
      var result;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              if (confirm('Please confirm you\'d like to delete this translation')) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              throbber.show();
              _context4.next = 6;
              return $http.delete("".concat(API_URL, "/api/v1/settings/translations/").concat(translationID));

            case 6:
              result = _context4.sent;
              tran.init();
              $rootScope.safeApply();
              throbber.hide('Translation deleted');
              _context4.next = 15;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](0);
              throbber.showError("Sorry but an error occurred: ".concat(_context4.t0.message));

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 12]]);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
}